import styled, { css } from 'styled-components'

import { Tokens } from '@/assets/tokens'

export const ComponentContainer = styled.div<{ $fit: boolean }>`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;

  ${({ $fit }) =>
    !$fit &&
    css`
      max-width: 20rem;
    `}
`

export const Label = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary};
`

export const SelectionContainer = styled.div<{ $inverted: boolean }>`
  width: 100%;
  height: ${Tokens.HeightInput};
  border-radius: ${Tokens.RadiusInput};
  padding: 0 16px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-weight: 400;

  color: ${Tokens.ColorTextPrimary};
  background-color: ${Tokens.ColorBackground};

  cursor: pointer;

  &:hover,
  &:focus-within {
    background-color: ${Tokens.ColorHover};
  }

  & > img {
    width: 1rem;
    height: 1rem;
  }

  ${({ $inverted }) =>
    $inverted &&
    css`
      background-color: ${Tokens.ColorUIPrimary};

      &:hover,
      &:focus-within {
        background-color: ${Tokens.ColorUIPrimaryDim};
      }

      & > input::placeholder {
        color: ${Tokens.ColorWhite};
      }
    `}
`

export const SelectedItem = styled.span<{ $placeholderColor: string }>`
  flex: 1;
  color: ${Tokens.ColorTextPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ $placeholderColor: placeholderColor }) => css`
    color: ${placeholderColor};
  `}
`

export const Selector = styled.ul<{ $show?: boolean }>`
  all: unset;

  top: ${Tokens.HeightInput};
  left: 0;

  border: ${Tokens.ColorWhite} solid 0.3rem;
  border-radius: 1rem;
  width: auto;
  min-width: 150px;
  height: fit-content;
  max-height: 25rem;
  padding: 0.5rem;
  overflow-y: auto;
  display: none;
  font-size: 14px;
  font-weight: 400;
  background-color: ${Tokens.ColorBackground};
  cursor: pointer;
  transition: display ease-in-out 0.25s;

  ${({ $show: show }) =>
    show &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      gap: 0.2rem;
    `}
`

export const SelectorOptions = styled.li`
  all: unset;
  color: ${Tokens.ColorTextPrimary};
  text-align: left;
  padding: 0.5rem;
  border-radius: 0.5rem;

  cursor: pointer;

  &:empty {
    height: 1rem;
  }

  &:hover {
    color: ${Tokens.ColorWhite};
    background-color: ${Tokens.ColorUIPrimary};
  }
`

export const PortalSelectorContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  position: absolute;
  border: ${Tokens.ColorWhite} solid 0.3rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  min-width: 150px;
  height: fit-content;
  max-height: 25rem;
  padding: 0.5rem;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 0.2rem;

  font-size: 14px;
  font-weight: 400;
  background-color: ${Tokens.ColorBackground};

  cursor: default;
`

export const PortalSelectorOptions = styled.li`
  all: unset;
  display: block;
  color: ${Tokens.ColorTextPrimary};
  text-align: left;
  padding: 0.5rem;
  border-radius: 0.5rem;

  cursor: pointer;

  &:empty {
    height: 1rem;
  }

  &:hover {
    color: ${Tokens.ColorWhite};
    background-color: ${Tokens.ColorUIPrimary};
  }
`
